import React from "react";
import { useStyles } from "../../../assets/jss/PraisoTable";
import CustomButton from "../CustomButton/CustomButton";

export default function ShowMoreOrLess(props) {
  const classes = useStyles();
  const [limitedRowOption, setLimitedRowOption] = React.useState({
    isVisible: true,
    buttonLabel: {
      1: "Show all drivers",
      0: "Show limited drivers",
    },
    currentLabel: 1,
  });
  React.useEffect(() => {
      setLimitedRowOption({...limitedRowOption, currentLabel: props.setShowMoreStatus})
  }, [props.setShowMoreStatus])
 
  return (
    <CustomButton className={classes.limitButton} onClick={() => props.updateShowMoreStatus(limitedRowOption.currentLabel === 1 ? 0 : 1)}>
      {limitedRowOption.buttonLabel[limitedRowOption.currentLabel]}
    </CustomButton>
  );
}
